import i18n from '@/lang/i18n';

export const SELECTABLE_ITEMS = {
  'alterLeaving': {
    'DailyReportAlterLeaving': i18n.global.t('pages.dailyReports.alterLeavingOrReturning.leavingTitle')
  },
  'alterReturning': {
    'DailyReportAlterReturning': i18n.global.t('pages.dailyReports.alterLeavingOrReturning.returningTitle')
  },
  'divide': {
    'DailyReportDivide': i18n.global.t('pages.dailyReports.splitForm.title')
  },
  'merge': {
    'DailyReportMerge': i18n.global.t('pages.dailyReports.mergeForm.title')
  },
  'recreate': {
    'DailyReportRecreate': i18n.global.t('pages.dailyReports.recreateForm.title')
  },
  'combine': {
    'DailyReportCombine': i18n.global.t('pages.dailyReports.combineForm.title')
  },
  'combine_rollback': {
    'DailyReportCombineRollback': i18n.global.t('pages.dailyReports.combineRollbackForm.title')
  }
}

export const PATH_SUFFIX_ALTER_LEAVING = 'alter-leaving';
export const PATH_SUFFIX_ALTER_RETURNING = 'alter-returning';
export const PATH_SUFFIX_DIVIDE = 'split';
export const PATH_SUFFIX_MERGE = 'merge';
export const PATH_SUFFIX_RECREATE = 'recreate';
export const PATH_SUFFIX_COMBINE = 'combine';
export const PATH_SUFFIX_COMBINE_ROLLBACK = 'combine-rollback';

export const COMBINE_HEADERS = [
  {
    key: 'tripId',
    class: 'col-md-2',
  },
  {
    key: 'numberPlate',
    class: 'col-md-2',
  },
  {
    key: 'leavingWarehouse',
    class: 'col-md-3',
  },
  {
    key: 'returningWarehouse',
    class: 'col-md-3',
  },
  {
    key: '',
    class: 'col-md-1',
  },
];
